import React, { useState, useEffect } from "react";

interface TimerProps {
  isRunningTime: boolean;
}

const Timer: React.FC<TimerProps> = ( {isRunningTime }) => {
  const [time, setTime] = useState<number>(0);
  
  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    
    if (isRunningTime) {
      intervalId = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [isRunningTime]);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return  <>{formatTime(time)}</>;
};

export default Timer;